import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import api, { apiErrorDetail } from "../lib/api";
import Reveal from "../components/Reveal";

export default function Contact() {
  const [f, setF] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", f);
      toast.success("MESSAGE SENT — WE'LL REPLY BY EMAIL SOON.");
      setF({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error(apiErrorDetail(err));
    }
    setBusy(false);
  };

  const inputCls = "w-full bg-transparent border border-white/15 focus:border-acid outline-none font-mono text-[11px] tracking-[0.2em] text-ink placeholder:text-mute px-4 py-3.5 transition-colors duration-300";

  return (
    <main className="px-5 md:px-10 pt-28 pb-24 max-w-3xl mx-auto">
      <Reveal>
        <p className="font-mono text-[11px] tracking-[0.3em] text-volt mb-3">WE REPLY TO EVERYTHING</p>
        <h1 className="font-display font-extrabold uppercase tracking-tighter text-3xl sm:text-5xl">TALK TO US</h1>
        <p className="font-mono text-[11px] tracking-widest text-dim mt-4 leading-relaxed">
          SIZING DOUBTS, ORDER UPDATES, COLLABS OR COMPLAINTS — WRITE IN. WE REPLY BY EMAIL, USUALLY WITHIN A DAY.
        </p>
      </Reveal>

      <Reveal delay={0.08}>
        <form onSubmit={submit} data-testid="contact-form" className="mt-10 space-y-4">
          <div className="grid sm:grid-cols-2 gap-4">
            <input className={inputCls} placeholder="YOUR NAME" value={f.name} onChange={set("name")} required maxLength={80} data-testid="contact-name-input" />
            <input className={inputCls} placeholder="YOUR EMAIL" type="email" value={f.email} onChange={set("email")} required maxLength={120} data-testid="contact-email-input" />
          </div>
          <textarea className={`${inputCls} min-h-[160px] resize-y`} placeholder="YOUR MESSAGE" value={f.message} onChange={set("message")} required maxLength={2000} data-testid="contact-message-input" />
          <button type="submit" disabled={busy} data-testid="contact-submit-btn" className="flex items-center gap-3 border border-acid text-acid font-display font-bold text-xs tracking-widest px-8 py-4 hover:bg-acid hover:text-void transition-colors duration-300 disabled:opacity-40">
            <Send size={13} /> {busy ? "SENDING…" : "SEND MESSAGE"}
          </button>
        </form>
      </Reveal>
    </main>
  );
}
